module.exports = __webpack_public_path__ + "e-learning-app/static/img/fourstart.31abb45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/fourstart.jpg
// module id = K+D3
// module chunks = 1